// External deps

import { Button, ContentCard } from 'ypf-pas-general-ui-components';
import { Formik } from 'formik';
import { BsChevronLeft } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import { postCreateAutomaticServiceRequest } from '../../services/automaticServiceRequest';
// Internal deps
import { initialValuesASDS } from '../../constants/constants';
import { ubicationTypeEnum } from '../../utils/dataStatus';
import { formatCreateASDS } from '../../utils/formatUtils';
import useToast from '../../hooks/useToast';
import ProviderAutomaticContainer from '../../components/ProvidersForm/ProviderAutomaticContainer';

import AutomaticService from './AutomaticCreateForm/AutomaticService/AutomaticService';
import AutomaticUbication from './AutomaticCreateForm/AutomaticUbication/AutomaticUbication';

import './AutomaticServiceRequest.scss';

const validationSchema = Yup.object().shape({
  ubication: Yup.object().shape({
    ubicationType: Yup.object().nullable().required('Seleccione tipo de ubicación'),
    uunn: Yup.object().nullable().required('Seleccione unidad de Negocio'),
    ubication: Yup.object().nullable().required('Ingrese ubicación'),
    event: Yup.object().nullable(),
    team: Yup.object().nullable(),
    service: Yup.object().shape({
      service: Yup.object().required('Ingrese servicio'),
      description: Yup.string()
        .min(1, 'Debe ingresar al menos un caracter')
        .required('Ingrese una descripción')
    }),
    provider: Yup.object().shape({
      providers: Yup.array({
        provider: Yup.object().required('Ingrese proveedor'),
        contract: Yup.object().required('Seleccione un contrato'),
        businessUnit: Yup.object().required('Seleccione una unidad de negocio'),
        notificate: Yup.object().required('Seleccione notificador')
      })
    })
  }),
  imputationObject: Yup.object().shape({
    wells: Yup.array().of(
      Yup.object().shape({
        well: Yup.object()
          .nullable()
          .required('Ingrese un pozo')
          .test('wellDuplicate', 'El pozo ya fue agregado', (item, data) => {
            const wellsArray = data?.from[3]?.value?.imputationObject?.wells;
            let error = true;
            const indexInput = Number(data.path.split('[')[1][0]);

            wellsArray?.forEach((well, i) => {
              if (well?.well?.value === item?.value && i !== indexInput) {
                error = false;
              }
            });

            return error;
          }),
        event: Yup.object()
          .test('eventDiff', 'Ingrese el mismo evento para todos los pozos', (item, data) => {
            const wellsArray = data?.from[3]?.value?.imputationObject?.wells;
            let error = true;
            const indexInput = Number(data.path.split('[')[1][0]);
            // El id es propio del evento
            // se mapea que value ahora es eventoPozoId
            // (lo cual esto es propio de la relación Evento-Pozo)
            // EventoPozoId y id (evento) son diferentes siempre
            const eventDiff = wellsArray?.some(
              (well, i) => well?.event?.id !== item?.id && i !== indexInput
            );

            if (item?.id) {
              if (eventDiff) {
                error = false;
              }
            }

            return error;
          })
          .nullable()
          .required('Seleccione un evento'),
        team: Yup.object().nullable().required('Seleccione un equipo'),
        imputationType: Yup.object().nullable().required('Seleccione un tipo de imputación'),
        imputationObject: Yup.object().nullable().required('Seleccione un objeto de imputación'),
        state: Yup.string().nullable(),
        budget: Yup.string().nullable(),
        logisticCenter: Yup.string().nullable(),
        socCode: Yup.string().nullable(),
        soc: Yup.array().of(Yup.string()).nullable(),
        description: Yup.string().nullable(),
        warningBudget: Yup.bool(),
        add: Yup.bool(),
        editable: Yup.bool()
      })
    )
  })
});

const AutomaticServiceRequest = () => {
  const history = useHistory();
  const { setNewToast } = useToast();

  const crearSolicitud = async (values) => {
    try {
      const formatedValues = formatCreateASDS(values);
      const solicitudCreada = await postCreateAutomaticServiceRequest(formatedValues);

      setNewToast({
        type: 'SUCCESS',
        message: solicitudCreada?.mensaje
      });
      history.push(`/detail/${solicitudCreada.id}`);
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  const completedUbicationForm = (values) => {
    const completedWellForm =
      values.ubication.ubicationType?.id === ubicationTypeEnum.pozo &&
      values.ubication.uunn &&
      values.ubication.ubication &&
      values.ubication.event &&
      values.ubication.team;

    const isCompletedDuctForm =
      values.ubication.ubicationType?.id === ubicationTypeEnum.ducto &&
      values.ubication.uunn &&
      values.ubication.ubication &&
      values.ubication.installation;

    const isCompletedRestLocations =
      values.ubication.ubicationType?.id !== ubicationTypeEnum.pozo &&
      values.ubication.ubicationType?.id !== ubicationTypeEnum.ducto &&
      values.ubication.uunn &&
      values.ubication.ubication &&
      values.imputationObject?.wells[0]?.event; // Se espera un pozo cargado en modal TyOI "Ver Detalles"

    return completedWellForm || isCompletedDuctForm || isCompletedRestLocations;
  };

  const completedProviderForm = (values) => {
    const baseValidation = !!(
      values?.provider?.providers[0]?.provider &&
      ((!values.isOyM && values?.provider?.providers[0]?.notificate) || values.isOyM) &&
      values?.provider?.providers[0]?.contract
    );

    return (
      (values?.provider?.moreBusinessUnits &&
        values?.provider?.providers[0].businessUnit &&
        baseValidation) ||
      (!values?.provider?.moreBusinessUnits && baseValidation)
    );
  };

  const completedServiceForm = (values) => values?.service?.service && values?.service?.description;

  return (
    <Formik initialValues={initialValuesASDS} validationSchema={validationSchema}>
      {({ values }) => (
        <div className="automatic-sds">
          <div className="title-asds d-flex">
            <Button
              colorIcon="primary"
              icon={BsChevronLeft}
              onClick={() => {
                history.push('/');
              }}
              type="button"
              variant="white"
              widthButton="42px"
            />
            <h2>Notificar avance de servicio sin solicitud</h2>
          </div>
          <ContentCard orientation="vertical">
            <AutomaticUbication createSDS />
            <hr />
            <ProviderAutomaticContainer
              disabled={!completedUbicationForm(values)}
              providerField="provider"
              providerValue={values.provider}
              values={values}
            />
            <hr />
            <AutomaticService
              disabled={!(completedUbicationForm(values) && completedProviderForm(values))}
            />
            <hr />
            <div className="d-flex justify-content-end">
              <Button
                disabled={
                  !(
                    completedUbicationForm(values) &&
                    completedProviderForm(values) &&
                    completedServiceForm(values)
                  )
                }
                label="Continuar"
                onClick={() => crearSolicitud(values)}
                type="button"
                variant="primary"
              />
            </div>
          </ContentCard>
          <div className="d-flex justify-content-center mt-4">
            <Button
              label="Salir"
              onClick={() => {
                history.push('/');
              }}
              type="button"
              variant="outline-primary"
              widthButton="70px"
            />
          </div>
        </div>
      )}
    </Formik>
  );
};

export default AutomaticServiceRequest;
